import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './ModalContent.css';

/**
 * Spacing helper for `<Modal />` content
 */
export default function ModalContent({ className, children }) {
  return <div className={classNames(styles.base, className)}>{children}</div>;
}

ModalContent.propTypes = {
  /** Add a custom className to the content */
  className: PropTypes.string,
  /** The actual content */
  children: PropTypes.node.isRequired,
};

ModalContent.displayName = 'ModalContent';
